import React from "react";
import { theme } from "antd";

/**
 * La cabecera de un producto —nombre, botones y Estado del producto— **queda fija al hacer
 * scroll** (xcons-docs#479), en la ficha, el formulario y la revisión. Lleva el fondo de la
 * página para tapar lo que pasa por debajo, y se estira sobre el padding de arriba del
 * layout y el espacio de abajo para que no se vea el contenido asomando por esos huecos.
 */
export const CabeceraFija: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { token } = theme.useToken();
  return (
    <div
      style={{
        position: "sticky",
        top: 0,
        zIndex: 10,
        display: "flex",
        flexDirection: "column",
        gap: 16,
        background: token.colorBgLayout,
        paddingTop: 24,
        marginTop: -24,
        paddingBottom: 16,
        marginBottom: -16,
      }}
    >
      {children}
    </div>
  );
};
